export const COOKIE_NAME = 'bSession';
export const SESSION_TTL = 30 * 60 * 1000; // 30 minutes
export const DEFAULT_CACHE_TTL = 10 * 1000; // 10 seconds
export const FREE_SITE_DOMAINS = ['.wixsite.com', '.editorx.io'];
export const WIX_DOMAINS = ['.wix.com', '.editorx.com'];
//# sourceMappingURL=constants.js.map